import { CommonAPI } from "../Client";

export const getSeoAPI = (params) => {
  return CommonAPI.get(`/seopages?page=${params?.page || 0}&size=${params?.size || 10}`)
  // return CommonAPI.get(`/seopages?page=0`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getSingleSeoAPI = (seoPagesTitle) => {
  return CommonAPI.get(`/seopages/${seoPagesTitle}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addSeoAPI = (payload) => {
  return CommonAPI.post("/seopages", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateSeoAPI = (payload) => {
  return CommonAPI.put("/seopages", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteSeoAPI = (id) => {
  return CommonAPI.delete(`/seopages/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const addSeoImgAPI = (payload) => {
  const formData = new FormData();
  formData.append("file", payload.file);

  return CommonAPI.post("/seopages/addthumbnail", formData, {
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryTtTi35D4MiWOz5uq",
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
